<template>
  <div class="ads-put-in-key">
    <div class="header-box">
      <span class="header-label">日期</span>
      <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="small"
        value-format="yyyy-MM-dd" style="width: 230px;">
      </el-date-picker>
      <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
    </div>
    <ads-table :tableData="tableData" :theadList="theadList" @image-click="(row) => imageClick(row)">
    </ads-table>
  </div>
</template>

<script>
  import adsTable from '_c/table'
  import {
    adsModules
  } from '@r'
  export default {
    data() {
      return {
        tableData: [],
        theadList: [{
            id: '1',
            propName: 'index',
            labelName: '序号',
          textAlign: "center",
          },
          {
            id: '2',
            propName: 'searchTerm',
            labelName: '买家搜索词'
          },
          {
            id: '4-1',
            propName: 'shopName',
            labelName: '商家名称'
          },
          {
            id: '10',
            propName: 'imageUrl',
            labelName: '商品图片',
            showImage: true
          },
          {
            id: '3',
            propName: 'keywordText',
            labelName: '关键词'
          },
          {
            id: '4',
            propName: 'matchType',
            labelName: '匹配类型'
          },
          {
            id: '3-1',
            propName: 'impressions',
            labelName: '曝光量',
            sortable: true,
            textAlign: "right",
          },
          {
            id: '5',
            propName: 'clicks',
            labelName: '点击次数',
            sortable: true,
            textAlign: "right",
          },
          {
            id: '3-2',
            propName: 'clickRate',
            labelName: '点击率',
            sortable: true,
            sortMethod: function (rowA, rowB){
              return parseFloat(rowA.clickRate)-parseFloat(rowB.clickRate);
            },
            textAlign: "right",
          },
          {
            id: '11',
            propName: 'averageSpend',
            labelName: '平均点击单价',
            sortMethod: function(rowA, rowB) {
              return parseFloat(rowA.sortAverageSpend) - parseFloat(rowB.sortAverageSpend);
            },
            textAlign: "right",
          },
          {
            id: '6',
            propName: 'spend',
            labelName: '花费',
            sortable: true,
            sortMethod: function (rowA, rowB){
              return parseFloat(rowA.spend)-parseFloat(rowB.spend);
            },
            textAlign: "right",
          },
          {
            id: '7',
            propName: 'orders',
            labelName: '订单数',
            sortable: true,
            textAlign: "right",
          },
          {
            id: '8',
            propName: 'sales',
            labelName: '销售额',
            sortable: true,
            sortMethod: function (rowA, rowB){
              return parseFloat(rowA.sales)-parseFloat(rowB.sales);
            },
            textAlign: "right",
          },
          {
            id: '9',
            propName: 'acos',
            labelName: 'ROAS',
            sortable: true,
            sortMethod: function (rowA, rowB){
              let subNumber = isNaN(parseFloat(rowA.acos)) ? 0 : parseFloat(rowA.acos);
              let nextNumber = isNaN(parseFloat(rowB.acos)) ? 0 : parseFloat(rowB.acos);
              return subNumber - nextNumber;
            },
            textAlign: "right",
          }
        ],
        groupId: null,
        searchType: null,
        date: [],
        pickerOptions: {
          shortcuts: [
            {
              text: '今天',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              id: 'yesterday',
              text: '前一天',
              onClick: (picker) => {
                console.log(this);
                const end = this.date[0] || '';
                const start = this.date[1] || '';
                const newEnd = new Date(new Date(start).setTime(new Date(start).getTime() - 3600 * 1000 * 24))
                const newStart =  new Date(new Date(end).setTime(new Date(end).getTime() - 3600 * 1000 * 24))
                picker.$emit('pick', [newStart, newEnd]);
              }
            },
            {
              text: '最近一周',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近一个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近三个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      }
    },
    components: {
      adsTable
    },
    created() {

    },
    activated() {
      // route.params.absType 1 2 自动, 4 关键词 3 5商品
      this.searchType = ['', 1, 1, 2, 2, 2][this.$route.query.absType];
      this.groupId = this.$route.query.groupId - 0;
      this.campaignId = this.$route.query.campaignsId - 0;

      const {beginDate, endDate} = this.$route.query;
      (beginDate || endDate) && (this.date = [beginDate, endDate]);
      this.queryAdsList();
    },
    mounted() {

    },
    methods: {
      onQueryBtnClick() {
        this.queryAdsList();
      },
      queryAdsList() {
        adsModules.getSearchItemList({
          // 请求参数
          params: {
            beginIndex: this.beginIndex,
            pageSize: this.pageSize,
            groupId: this.groupId,
            campaignId: this.campaignId,
            type: this.searchType,
            beginDate: this.date[0],
            endDate: this.date[1],
            dsTimeZone: 1
          }
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取列表失败'
            });
            return
          }
          this.tableData = res.ldata;
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '系统错误'
          });
        })
        return []
      },
      imageClick(row) {
        window.open(row.productUrl);
      }
    }
  }
</script>

<style lang="scss">
</style>
